/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosInstance, AxiosResponse } from "axios";

//Function to get cloud connections list data
export function fetchCloudList(
    api: AxiosInstance,
    tenantId: number,
  ): Promise<AxiosResponse> {
  return api.get(`/kontroledge/cloud-connectivity?tenantId=${tenantId}&includeChildServices=true`, {
  });
}

//Function to get the cloud detail
export function fetchCloudConnectionAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}?tenantId=${tenantId}`);
}

export function fetchCloudPerformanceAPI(
  api: AxiosInstance,
  connectionId: string,
  timeRange: string | undefined,
  interval: string,
  tenantId: number,
  startDate?: string,  // ISO string
  endDate?: string,    // ISO string
  maxPoints?: number
): Promise<AxiosResponse> {
  const params: Record<string, unknown> = { interval, tenantId };
  
  // Use custom date range if provided, otherwise use timeRange preset
  if (startDate && endDate) {
    params.start = startDate;
    params.end = endDate;
    if (maxPoints) params.maxPoints = maxPoints;
  } else if (timeRange) {
    params.timeRange = timeRange;
  }
  
  return api.get(`/kontroledge/cloud-connectivity/${connectionId}/performance`, {
    params,
  });
}

//Function to get the cloud subscription Info
export function fetchCloudSubscriptionAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}/subscription?tenantId=${tenantId}`);
}

//Function to get the cloud errors
export function fetchCloudErrorsAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}/crc-errors?timeRange=1d&tenantId=${tenantId}`, {
});
}

//Function to get the cloud connectivity provider
export function fetchCloudProvidersAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}/provider?tenantId=${tenantId}`, {
});
}

//Function to get the cloud connectivity operational history
export function fetchCloudHistoryAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
  limit: number // Default alto para obtener todos los registros
): Promise<AxiosResponse> {
  return api.get(`/kontroledge/cloud-connectivity/${connectionId}/operational-history?tenantId=${tenantId}&limit=${limit}`);
}
